export const SAXO_SET_STATE = 'SAXO_SET_STATE';
export const SAXO_UPDATE_CURRENCY_ACCOUNTS = 'SAXO_UPDATE_CURRENCY_ACCOUNTS';
